import { ajaxCart } from './ajax-cart'
import { clearCart } from './clear-cart'
import { updateCart } from './update-cart'
import { clickOutside } from '../click-events/click-outside'

const $win = $(window)
const $doc = $(document)
const $widgetCart = $('.js-widget-cart')

ajaxCart(true, false)

// Remove Elements From Cart
$doc.on('click', '.js-cart-remove', function (e) {
  e.preventDefault()
  const $this = $(this)
  const $form = $this.closest('form')
  const productId = parseInt($this.attr('href'))

  updateCart($form, true, productId)
})

$doc.on('click', '.js-btn-clear-cart', function (e) {
  e.preventDefault()

  clearCart(true)
})

$doc.on('click', function (e) {
  clickOutside(e, 'js-widget-cart', 'is-expanded', 'js-btn-cart')
})
